import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import HeroSlider from "@/components/HeroSlider";
import Services from "@/components/Services";
import EditorialMarquee from "@/components/EditorialMarquee";
import AISection from "@/components/AISection";
import About from "@/components/About";
import Products from "@/components/Products";
import CTABand from "@/components/CTABand";
import Blog from "@/components/Blog";
import Testimonials from "@/components/Testimonials";
import Footer from "@/components/Footer";
import AboutUs from "@/pages/AboutUs";
import Careers from "@/pages/Careers";
import OurProducts from "@/pages/OurProducts";
import TechnologyServices from "@/pages/TechnologyServices";
import GenerativeAI from "@/pages/GenerativeAI";
import DigitalTransformation from "@/pages/DigitalTransformation";
import BusinessApplications from "@/pages/BusinessApplications";
import DataIntelligence from "@/pages/DataIntelligence";
import AppsInfrastructure from "@/pages/AppsInfrastructure";
import ProfessionalServices from "@/pages/ProfessionalServices";
import ContactUs from "@/pages/ContactUs";
import BlogListing from "@/pages/BlogListing";
import BlogPost from "@/pages/BlogPost";
import NotFound from "@/pages/NotFound";
import SEO, { buildBreadcrumbJsonLd } from "@/components/SEO";
import { seoConfig } from "@/data/seoConfig";

const Home = () => (
  <main>
    <SEO {...seoConfig.home} jsonLd={[buildBreadcrumbJsonLd(seoConfig.home.crumbs)]} />
    <HeroSlider />
    <Services />
    <EditorialMarquee />
    <AISection />
    <About />
    <Products />
    <CTABand />
    <Blog />
    <Testimonials />
  </main>
);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="bg-white font-body text-slate-900 overflow-x-clip">
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/our-products" element={<OurProducts />} />
          <Route path="/services/technology-services" element={<TechnologyServices />} />
          <Route path="/services/generative-ai" element={<GenerativeAI />} />
          <Route path="/services/digital-transformation" element={<DigitalTransformation />} />
          <Route path="/services/business-applications" element={<BusinessApplications />} />
          <Route path="/services/data-and-intelligence" element={<DataIntelligence />} />
          <Route path="/services/apps-and-infrastructure" element={<AppsInfrastructure />} />
          <Route path="/services/professional-services" element={<ProfessionalServices />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/blog" element={<BlogListing />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        <Toaster position="bottom-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;
